"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChoiceElementType = void 0;
exports.choiceOptionReferenceValue = choiceOptionReferenceValue;
exports.choiceQuestionLabel = choiceQuestionLabel;
/** SINGLE_SELECT / MULTI_SELECT — questions whose options are placed independently on the PDF. */
const CHOICE_ELEMENT_TYPES = ['SINGLE_SELECT', 'MULTI_SELECT'];
const isChoiceElementType = (type) => CHOICE_ELEMENT_TYPES.includes(type);
exports.isChoiceElementType = isChoiceElementType;
/**
 * Resolves an option's backend-only reference value, falling back to the stringified integer key when
 * the author left the panel's "Value" field blank.
 *
 * Custom / multi-select options default to an empty `value` (the marker only shows the number), so
 * without this fallback the projected `ec__selection_options` pair becomes `key=` — an empty value that
 * `parseSelectionOptions` drops on read. That silently makes the option unrepresentable server-side: a
 * participant's checkbox toggle persists an empty `ec__value` and never renders on the site app (which
 * reads only server truth), even though the patient app still shows it from its optimistic local buffer.
 * Keying the value off the option number keeps `ec__selection_options` and the bundle's choice geometry
 * in lockstep and always non-empty.
 */
function choiceOptionReferenceValue(option) {
    const trimmed = typeof option.value === 'string' ? option.value.trim() : '';
    return trimmed.length > 0 ? trimmed : String(option.key);
}
/**
 * The one author-entered name a choice question has, for the places that show it back to the author —
 * the option marker's accessible name and the unplaced-options publish blocker. `ec__title` and
 * `ec__key` are deliberately not fallbacks: the first is auto-filled with a generated id the moment an
 * element is opened for configuration (see `generate_unique_id.ts`) and the second is a uuid, so
 * either one names the question with a string the author has never seen.
 */
function choiceQuestionLabel(config) {
    var _a;
    return ((_a = config.ec__question_label) === null || _a === void 0 ? void 0 : _a.trim()) || undefined;
}
//# sourceMappingURL=choice_options.js.map